import React from 'react'

// material ui
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import CircularProgress from '@mui/material/CircularProgress'

// components
import ProductMenu from './ProductMenu'
import DayPassProduct from './DayPassProduct'
import PricingNotice from './PricingNotice'
import QueryErrors from './QueryErrors'

const SelectProduct = props => {
  const {
    loading,
    camper,
    session,
    cartProduct,
    plan, // withQuery
    product, // via withQuery
    location,
    camperSession, // via withQuery
    onChangeProduct, // via withEventHandlers
    inputErrors, // via withFormResults
    hideUI // from parent - hides UI but still runs query for product auto-selection
  } = props

  // don't display product selection for unlimited plans
  if (plan && plan.unlimited) {
    return null
  }

  // Hide UI when date selection is active, but still allow query to run
  if (hideUI) {
    return null
  }

  // redeemable pass product
  if (product && !product.retail) {
    return (
      <Box mt={2} my={1}>
        <DayPassProduct
          product={product}
          camperSession={camperSession}
          cartProduct={cartProduct}
        />
      </Box>
    )
  }

  // detect any product selection validation errors for this camper and session
  const errors = inputErrors.filter(
    e =>
      product &&
      e.path[0] === 'attributes' &&
      e.path[1] === 'cart_products' &&
      ['product_id', 'days'].includes(e.path[2]) &&
      e.path[3] === camper.id &&
      e.path[4] === product.id
  )

  return (
    <Box mt={2}>
      <FormControl component='fieldset' error={!!errors.length} fullWidth>
        <FormLabel component='legend'>
          2. Select number of days to purchase
        </FormLabel>

        <PricingNotice camperSession={camperSession} product={product} />

        {loading && (
          <Box my={4}>
            <CircularProgress color='primary' />
          </Box>
        )}

        <QueryErrors errors={errors} />

        {!loading && product && (
          <ProductMenu
            camper={camper}
            session={session}
            plan={plan}
            product={product}
            location={location}
            cartProduct={cartProduct}
            camperSession={camperSession}
            onChangeProduct={onChangeProduct}
            account={props.account}
          />
        )}
      </FormControl>
    </Box>
  )
}

export default SelectProduct
